import { useEffect, useState } from "react";
import toast from "../../../../utils/toast";
import * as XLSX from "xlsx";
import {
  getUsers,
  getStateWithApi,
  getMasterPincode,
  createUser,
  getUserById,
  updateUserById,
  toggleUserStatusById,
  resendPasswordToUser,
  getUserLedgerById,
  userFundTransferById,
} from "../../../../services/admin/adminServices";

export default function Users() {
  const [isModalOpenAdduser, setModalOpenAdduser] = useState(false);
  const [isModalOpenKyc, setIsModalOpenKyc] = useState(false);
  const [isModalOpenFund, setIsModalOpenFund] = useState(false);
  const [isModalOpenLedger, setIsModalOpenLedger] = useState(false);
  const [isModalOpenEditUser, setIsModalOpenEditUser] = useState(false);
  const [users, setUsers] = useState();
  const [states, setStates] = useState([]);
  const [addUserForm, setAddUserForm] = useState({
    fullName: "",
    email: "",
    mobile: "",
    whatsApp: "",
    password: "",
    roleId: 2,
    pincode: "",
    district: "",
    stateId: 0,
    address: "",
    landmark: "",
    pan: "",
    aadhaar: "",
    dob: "",
    bankName: "",
    ifsc: "",
    accountNumber: "",
    accountHolder: "",
    notes: "",
  });
  const [addUserErrors, setAddUserErrors] = useState({});
  const [addUserLoading, setAddUserLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editUserForm, setEditUserForm] = useState({});
  const [editUserErrors, setEditUserErrors] = useState({});
  const [editUserLoading, setEditUserLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    UserId: "",
    Search: "",
    IsActive: "",
    KycStatus: "",
    Page: 1,
    PageSize: 10,
  });
  const [listLoading, setListLoading] = useState(true);

  const [selectedUserForAction, setSelectedUserForAction] = useState(null);

  // Ledger
  const [ledgerData, setLedgerData] = useState(null);
  const [ledgerLoading, setLedgerLoading] = useState(false);

  // Fund Transfer
  const [fundForm, setFundForm] = useState({
    transferType: 1,
    amount: "",
    remark: "",
  });
  const [fundLoading, setFundLoading] = useState(false);

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [filters]);

  const fetchStates = async () => {
    try {
      const res = await getStateWithApi();
      setStates(res);
    } catch (err) {
      console.log("Failed to fetch states");
    }
  };

  const handleAddPincodeChange = async (e) => {
    const val = e.target.value;
    handleAddUserChange(e);

    if (val.length === 6) {
      try {
        const res = await getMasterPincode(val);
        if (res.statusCode === 1) {
          setAddUserForm((prev) => ({
            ...prev,
            district: res.data.district,
            stateId: Number(res.data.stateId),
          }));
        }
      } catch (err) {
        console.log("Pincode not found");
      }
    } else {
      setAddUserForm((prev) => ({ ...prev, district: "", stateId: 0 }));
    }
  };

  const handleEditPincodeChange = async (e) => {
    const val = e.target.value;
    handleEditUserChange(e);

    if (val.length === 6) {
      try {
        const res = await getMasterPincode(val);
        if (res.statusCode === 1) {
          setEditUserForm((prev) => ({
            ...prev,
            district: res.data.district,
            stateId: Number(res.data.stateId),
          }));
        }
      } catch (err) {
        console.log("Pincode not found");
      }
    } else {
      setEditUserForm((prev) => ({
        ...prev,
        district: "",
        stateId: 0,
      }));
    }
  };

  const StateDropdown = ({ name, value, onChange }) => (
    <select name={name} value={Number(value)} onChange={onChange}>
      <option value={0}>Select State</option>
      {states.map((s) => (
        <option key={s.stateId} value={s.stateId}>
          {s.stateName}
        </option>
      ))}
    </select>
  );

  const fetchUsers = async () => {
    setListLoading(true);
    try {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      );
      //  await new Promise((resolve) => setTimeout(resolve, 5000));
      const res = await getUsers(params);
      setUsers(res.data.items);
      setTotalCount(res.data.totalCount);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      console.log(err.response?.data?.message || "Failed to fetch users");
    } finally {
      setListLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value, Page: 1 }));
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({ ...prev, Page: page }));
  };

  const handleAddUserChange = (e) => {
    const { name, value } = e.target;
    setAddUserForm((prev) => ({ ...prev, [name]: value }));
    setAddUserErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateAddUser = () => {
    const e = {};
    if (!addUserForm.fullName) e.fullName = "Full name is required.";
    if (!addUserForm.mobile) e.mobile = "Mobile number is required.";
    if (!addUserForm.email) e.email = "Email is required.";
    if (!addUserForm.password || addUserForm.password.length < 8)
      e.password = "Password must be at least 8 characters.";
    if (!addUserForm.pincode) e.pincode = "Pincode is required.";
    if (!addUserForm.address) e.address = "Address is required.";
    setAddUserErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleCreateUser = async () => {
    if (!validateAddUser()) return;
    setAddUserLoading(true);
    try {
      const payload = {
        ...addUserForm,
        stateId: Number(addUserForm.stateId),
        roleId: Number(addUserForm.roleId),
        dob: addUserForm.dob ? new Date(addUserForm.dob).toISOString() : null,
      };

      const res = await createUser(payload);
      if (res.statusCode === 1) {
        toast.success(res.message || "User created successfully.");
        setModalOpenAdduser(false);
        setAddUserForm({
          fullName: "",
          email: "",
          mobile: "",
          whatsApp: "",
          password: "",
          roleId: 2,
          pincode: "",
          district: "",
          stateId: 0,
          address: "",
          landmark: "",
          pan: "",
          aadhaar: "",
          dob: "",
          bankName: "",
          ifsc: "",
          accountNumber: "",
          accountHolder: "",
          notes: "",
        });
        fetchUsers();
      } else {
        toast.error(res.message || "Failed to create user.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setAddUserLoading(false);
    }
  };

  const closeAddUserModal = () => {
    setModalOpenAdduser(false);
    setAddUserForm({
      fullName: "",
      email: "",
      mobile: "",
      whatsApp: "",
      password: "",
      roleId: 2,
      pincode: "",
      district: "",
      stateId: 0,
      address: "",
      landmark: "",
      pan: "",
      aadhaar: "",
      dob: "",
      bankName: "",
      ifsc: "",
      accountNumber: "",
      accountHolder: "",
      notes: "",
    });
    setAddUserErrors({});
  };

  const openEditUser = async (userId) => {
    try {
      const res = await getUserById(userId);
      if (res.statusCode === 1) {
        const u = res.data;
        setSelectedUser(u);
        setEditUserForm({
          fullName: u.fullName || "",
          email: u.email || "",
          mobile: u.mobile || "",
          whatsApp: u.whatsApp || "",
          pincode: u.pincode || "",
          district: u.district || "",
          stateId: Number(u.stateId) || 0,
          address: u.address || "",
          landmark: u.landmark || "",
          pan: u.pan || "",
          aadhaar: u.aadhaar || "",
          dob: u.dob ? u.dob.split("T")[0] : "",
          bankName: u.bankName || "",
          ifsc: u.ifsc || "",
          accountNumber: u.accountNumber || "",
          accountHolder: u.accountHolder || "",
          notes: u.notes || "",
        });
        setEditUserErrors({});
        setIsModalOpenEditUser(true);
      }
    } catch (err) {
      toast.error("Failed to load user details.");
    }
  };

  const closeEditUserModal = () => {
    setIsModalOpenEditUser(false);
    setSelectedUser(null);
    setEditUserForm({});
    setEditUserErrors({});
  };

  const handleEditUserChange = (e) => {
    const { name, value } = e.target;
    setEditUserForm((prev) => ({ ...prev, [name]: value }));
    setEditUserErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateEditUser = () => {
    const e = {};
    if (!editUserForm.fullName) e.fullName = "Full name is required.";
    if (!editUserForm.mobile) e.mobile = "Mobile number is required.";
    if (!editUserForm.email) e.email = "Email is required.";
    if (!editUserForm.pincode) e.pincode = "Pincode is required.";
    if (!editUserForm.address) e.address = "Address is required.";
    setEditUserErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleUpdateUser = async () => {
    if (!validateEditUser()) return;
    setEditUserLoading(true);
    try {
      const payload = {
        ...editUserForm,
        stateId: Number(editUserForm.stateId),
        dob: editUserForm.dob ? new Date(editUserForm.dob).toISOString() : null,
      };
      const res = await updateUserById(selectedUser.userId, payload);
      if (res.statusCode === 1) {
        toast.success(res.message || "User updated successfully.");
        closeEditUserModal();
        fetchUsers();
      } else {
        toast.error(res.message || "Failed to update user.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setEditUserLoading(false);
    }
  };

  const handleToggleStatus = async (userId, status) => {
    try {
      const payload = {
        isActive: !status,
      };
      const res = await toggleUserStatusById(userId, payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        fetchUsers();
      }
    } catch (err) {
      toast.error("Failed to toggle user status.");
    }
  };

  const handleExportCSV = async () => {
    try {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      );
      const res = await getUsers({ ...params, IsExport: true });
      const items = res.data.items;

      const exportData = items.map((user) => ({
        "User ID": user.userId ?? "",
        "Full Name": user.fullName ?? "",
        Email: user.email ?? "",
        Mobile: user.mobile ?? "",
        WhatsApp: user.whatsApp ?? "",
        Role: user.roleName ?? "",
        Status: user.isActive ? "Active" : "Inactive",
        "KYC Status": user.kycStatus === 1 ? "Verified" : "Pending",
        "Wallet Balance": user.walletBalance ?? 0,
        Pincode: user.pincode ?? "",
        District: user.district ?? "",
        State: user.stateName ?? "",
        Package: user.packageName ?? "",
        "Reg Date": user.createdAt
          ? new Date(user.createdAt).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

      XLSX.writeFile(
        workbook,
        `users_export_${new Date().toISOString().slice(0, 10)}.xlsx`,
      );
    } catch (err) {
      toast.error("Export failed. Please try again.");
    }
  };

  const openLedgerModal = async (user) => {
    setSelectedUserForAction(user);
    setLedgerData(null);
    setLedgerLoading(true);
    setIsModalOpenLedger(true);
    try {
      const res = await getUserLedgerById(user.userId);
      if (res.statusCode === 1) setLedgerData(res.data);
      else toast.error(res.message);
    } catch {
      toast.error("Failed to load ledger.");
    } finally {
      setLedgerLoading(false);
    }
  };

  const openFundModal = (user) => {
    setSelectedUserForAction(user);
    setFundForm({ transferType: 1, amount: "", remark: "" });
    setIsModalOpenFund(true);
  };

  const handleFundTransfer = async () => {
    if (!fundForm.amount) {
      toast.error("Amount is required.");
      return;
    }
    if (!fundForm.remark.trim()) {
      toast.error("Remark is required.");
      return;
    }
    setFundLoading(true);
    try {
      const res = await userFundTransferById(selectedUserForAction.userId, {
        transferType: Number(fundForm.transferType),
        amount: Number(fundForm.amount),
        remark: fundForm.remark,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        setIsModalOpenFund(false);
        fetchUsers();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to transfer funds.");
    } finally {
      setFundLoading(false);
    }
  };

  const handleResendPassword = async (userId) => {
    try {
      const res = await resendPasswordToUser(userId);
      if (res.statusCode === 1) toast.success(res.message);
      else toast.error(res.message);
    } catch {
      toast.error("Failed to resend password.");
    }
  };

  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              User List
            </div>
            <div className="page-sub" id="page-sub">
              User Management › User List
            </div>
          </div>
          <div className="topbar-right" id="topbar-right">
            <button
              className="btn btn-primary"
              onClick={() => {
                setAddUserErrors({});
                setAddUserForm({
                  fullName: "",
                  email: "",
                  mobile: "",
                  whatsApp: "",
                  password: "",
                  roleId: 2,
                  pincode: "",
                  district: "",
                  stateId: 0,
                  address: "",
                  landmark: "",
                  pan: "",
                  aadhaar: "",
                  dob: "",
                  bankName: "",
                  ifsc: "",
                  accountNumber: "",
                  accountHolder: "",
                  notes: "",
                });
                setModalOpenAdduser(true);
              }}
            >
              + Add New User
            </button>
          </div>
        </div>
        <div className="content" id="content-area">
          <div className="card">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 14,
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              <div className="flex-gap8" style={{ flexWrap: "wrap" }}>
                <input
                  type="number"
                  name="UserId"
                  value={filters.UserId}
                  onChange={handleFilterChange}
                  placeholder="Search by User ID"
                  style={{ fontSize: 12, padding: "6px 10px", width: 140 }}
                />
                <input
                  type="text"
                  name="Search"
                  value={filters.Search}
                  onChange={handleFilterChange}
                  placeholder="🔍 Search name, mobile, email…"
                  style={{ fontSize: 12, padding: "6px 10px", width: 210 }}
                />
                <select
                  name="IsActive"
                  value={filters.IsActive}
                  onChange={handleFilterChange}
                  style={{ fontSize: 12, padding: "5px 8px", width: "auto" }}
                >
                  <option value="">All Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
                <select
                  name="KycStatus"
                  value={filters.KycStatus}
                  onChange={handleFilterChange}
                  style={{ fontSize: 12, padding: "5px 8px", width: "auto" }}
                >
                  <option value="">All KYC</option>
                  <option value="1">Verified</option>
                  <option value="0">Pending</option>
                </select>

                {(filters.Search ||
                  filters.IsActive ||
                  filters.KycStatus ||
                  filters.UserId) && (
                  <button
                    className="btn btn-lg"
                    style={{ background: "#185fa5", color: "#fff" }}
                    onClick={() =>
                      setFilters({
                        Search: "",
                        IsActive: "",
                        KycStatus: "",
                        UserId: "",
                        Page: 1,
                        PageSize: 10,
                      })
                    }
                  >
                    Reset
                  </button>
                )}
              </div>

              <button className="btn btn-sm" onClick={handleExportCSV}>
                Export Excel
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th>S.N.</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Balance</th>
                    <th>Status</th>
                    <th>KYC</th>
                    <th>Email</th>
                    <th>District</th>
                    <th>State</th>
                    <th>Pincode</th>
                    <th>Package</th>
                    <th>Reg Date</th>
                    <th style={{ minWidth: 170 }}>Actions</th>
                  </tr>
                </thead>

                <tbody id="user-tbody">
                  {listLoading ? (
                    Array.from({ length: 8 }).map((_, i) => (
                      <tr key={i}>
                        {Array.from({ length: 13 }).map((_, j) => (
                          <td key={j}>
                            <div
                              style={{
                                height: 14,
                                borderRadius: 6,
                                background:
                                  "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                                backgroundSize: "200% 100%",
                                animation: "shimmer 1.4s infinite",
                                width:
                                  j === 1 ? "80%" : j === 12 ? "60%" : "70%",
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : users?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={13}
                        style={{
                          textAlign: "center",
                          color: "var(--text-tertiary)",
                          padding: 24,
                        }}
                      >
                        No users found.
                      </td>
                    </tr>
                  ) : (
                    users?.map((user, index) => (
                      <tr key={user?.userId || index}>
                        <td className="sn-col">
                          {(filters.Page - 1) * filters.PageSize + index + 1}
                        </td>
                        <td style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                          {user?.fullName || "—"}
                          <div
                            style={{
                              fontSize: 11,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            [{user?.userId || ""}]
                          </div>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {user?.mobile || "—"}
                        </td>
                        <td>
                          <strong style={{ color: "var(--blue)" }}>
                            {user?.walletBalance != null
                              ? `₹${user.walletBalance}`
                              : "—"}
                          </strong>
                        </td>
                        <td>
                          <span
                            className={`badge ${user.isActive ? "badge-active" : "badge-inactive"}`}
                          >
                            {user.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge ${user.kycStatus === "Verified" ? "badge-active" : "badge-warn"}`}
                          >
                            {user.kycStatus || "Pending"}
                          </span>
                        </td>
                        <td style={{ fontSize: 11 }}>{user.email || "—"}</td>
                        <td>{user.district || "—"}</td>
                        <td>{user.stateName || "—"}</td>
                        <td>{user.pincode || "—"}</td>
                        <td>
                          {user.packageName ? (
                            <span className="badge badge-info">
                              {user.packageName}
                            </span>
                          ) : (
                            "—"
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {user.createdAt
                            ? new Date(user.createdAt).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : "—"}
                        </td>
                        <td>
                          <div className="td-actions">
                            <span
                              className="action-icon"
                              onClick={() => setIsModalOpenKyc(true)}
                              title="View Details & KYC"
                              style={{
                                background: "var(--blue-light)",
                                borderColor: "#85B7EB",
                              }}
                            >
                              <span className="tip">View Details</span>👁
                            </span>
                            <span
                              className="action-icon"
                              onClick={() => openEditUser(user.userId)}
                              title="Edit"
                            >
                              <span className="tip">Edit</span>✎
                            </span>
                            <span
                              className="action-icon"
                              title="Resend Password"
                              onClick={() => handleResendPassword(user.userId)}
                            >
                              <span className="tip">Resend Pwd</span>🔑
                            </span>
                            <span
                              className="action-icon amber"
                              title="Change Status"
                              onClick={() =>
                                handleToggleStatus(user.userId, user.isActive)
                              }
                            >
                              <span className="tip">Toggle Status</span>⇄
                            </span>
                            <span
                              className="action-icon green"
                              onClick={() => openFundModal(user)}
                              title="Fund Transfer"
                            >
                              <span className="tip">Fund Transfer</span>₹
                            </span>
                            <span
                              className="action-icon"
                              onClick={() => openLedgerModal(user)}
                              title="View Ledger"
                            >
                              <span className="tip">Ledger</span>📋
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "var(--text-secondary)",
              }}
            >
              <div className="flex-gap8" style={{ alignItems: "center" }}>
                <select
                  name="PageSize"
                  value={filters.PageSize}
                  onChange={handleFilterChange}
                  style={{ fontSize: 12, padding: "4px 8px" }}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>
                <span>
                  Showing <strong>{users?.length}</strong> of
                  <strong>{totalCount}</strong>
                </span>
              </div>

              <div className="flex-gap8">
                <button
                  className="btn btn-xs"
                  disabled={filters.Page === 1}
                  onClick={() => handlePageChange(filters.Page - 1)}
                >
                  ‹ Prev
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <span
                      key={page}
                      onClick={() => handlePageChange(page)}
                      style={{
                        padding: "2px 8px",
                        background:
                          filters.Page === page ? "var(--blue)" : "transparent",
                        color:
                          filters.Page === page
                            ? "#fff"
                            : "var(--text-secondary)",
                        borderRadius: 5,
                        fontSize: 11,
                        cursor: "pointer",
                        border:
                          filters.Page === page
                            ? "none"
                            : "1px solid var(--border-mid)",
                      }}
                    >
                      {page}
                    </span>
                  ),
                )}

                <button
                  className="btn btn-xs"
                  disabled={filters.Page === totalPages}
                  onClick={() => handlePageChange(filters.Page + 1)}
                >
                  Next ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add new user */}
      {isModalOpenAdduser && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 700 }}>
            <div className="modal-header">
              <div className="modal-title">Add New User (Property Owner)</div>
              <button className="modal-close" onClick={closeAddUserModal}>
                ✕
              </button>
            </div>

            <div className="modal-body">
              <div className="info-box" style={{ display: "block" }}>
                New user will receive login credentials via SMS and Email after
                registration.
              </div>

              {/* ── Basic Information ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Basic Information
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    value={addUserForm.fullName}
                    onChange={handleAddUserChange}
                    placeholder="Enter full name"
                    style={
                      addUserErrors.fullName ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {addUserErrors.fullName && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addUserErrors.fullName}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Mobile Number *</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={addUserForm.mobile}
                    onChange={handleAddUserChange}
                    placeholder="+91 XXXXX XXXXX"
                    style={
                      addUserErrors.mobile ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {addUserErrors.mobile && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addUserErrors.mobile}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={addUserForm.email}
                    onChange={handleAddUserChange}
                    placeholder="email@example.com"
                    style={
                      addUserErrors.email ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {addUserErrors.email && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addUserErrors.email}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>WhatsApp Number</label>
                  <input
                    type="tel"
                    name="whatsApp"
                    value={addUserForm.whatsApp}
                    onChange={handleAddUserChange}
                    placeholder="+91 XXXXX XXXXX (if different from mobile)"
                  />
                </div>

                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="text"
                    name="password"
                    value={addUserForm.password}
                    onChange={handleAddUserChange}
                    placeholder="Min 8 characters"
                    style={
                      addUserErrors.password ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {addUserErrors.password && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addUserErrors.password}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    name="dob"
                    value={addUserForm.dob}
                    onChange={handleAddUserChange}
                  />
                </div>

                <div className="form-group">
                  <label>Pincode *</label>
                  <input
                    type="text"
                    name="pincode"
                    value={addUserForm.pincode}
                    onChange={handleAddPincodeChange}
                    placeholder="6-digit pincode"
                    maxLength={6}
                    style={
                      addUserErrors.pincode ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {addUserErrors.pincode && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addUserErrors.pincode}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>District</label>
                  <input
                    type="text"
                    name="district"
                    value={addUserForm.district}
                    onChange={handleAddUserChange}
                    placeholder="Auto-filled from pincode"
                    style={{
                      background: addUserForm.district
                        ? "var(--bg-secondary)"
                        : "",
                    }}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>State</label>
                <StateDropdown
                  name="stateId"
                  value={addUserForm.stateId}
                  onChange={handleAddUserChange}
                />
              </div>

              <div className="form-group full">
                <label>Complete Address *</label>
                <textarea
                  name="address"
                  value={addUserForm.address}
                  onChange={handleAddUserChange}
                  placeholder="House/Flat No., Street, Area, City, State, Pincode"
                  style={{
                    minHeight: 52,
                    ...(addUserErrors.address
                      ? { borderColor: "#dc2626" }
                      : {}),
                  }}
                />
                {addUserErrors.address && (
                  <span style={{ color: "#dc2626", fontSize: 11 }}>
                    {addUserErrors.address}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Landmark</label>
                <input
                  type="text"
                  name="landmark"
                  value={addUserForm.landmark}
                  onChange={handleAddUserChange}
                  placeholder="Near landmark"
                />
              </div>

              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  margin: "14px 0",
                }}
              />

              {/* ── KYC Information ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                KYC Information
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>PAN</label>
                  <input
                    type="text"
                    name="pan"
                    value={addUserForm.pan}
                    onChange={handleAddUserChange}
                    placeholder="ABCDE1234F"
                    maxLength={10}
                  />
                </div>
                <div className="form-group">
                  <label>Aadhaar</label>
                  <input
                    type="text"
                    name="aadhaar"
                    value={addUserForm.aadhaar}
                    onChange={handleAddUserChange}
                    placeholder="XXXX XXXX XXXX"
                    maxLength={12}
                  />
                </div>
              </div>

              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  margin: "14px 0",
                }}
              />

              {/* ── Bank Details ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Bank Details
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    value={addUserForm.bankName}
                    onChange={handleAddUserChange}
                    placeholder="Bank name"
                  />
                </div>
                <div className="form-group">
                  <label>IFSC Code</label>
                  <input
                    type="text"
                    name="ifsc"
                    value={addUserForm.ifsc}
                    onChange={handleAddUserChange}
                    placeholder="SBIN0012345"
                  />
                </div>
                <div className="form-group">
                  <label>Account Number</label>
                  <input
                    type="text"
                    name="accountNumber"
                    value={addUserForm.accountNumber}
                    onChange={handleAddUserChange}
                    placeholder="Account number"
                  />
                </div>
                <div className="form-group">
                  <label>Account Holder</label>
                  <input
                    type="text"
                    name="accountHolder"
                    value={addUserForm.accountHolder}
                    onChange={handleAddUserChange}
                    placeholder="As per bank records"
                  />
                </div>
              </div>

              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  margin: "14px 0",
                }}
              />

              {/* ── Account Settings ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Account Settings
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>KYC Status</label>
                  <div
                    style={{
                      padding: "8px 10px",
                      borderRadius: "var(--radius-md)",
                      border: "0.5px solid var(--border-mid)",
                      background: "var(--bg-secondary)",
                      fontSize: 13,
                      color: "var(--amber)",
                    }}
                  >
                    Pending (auto-set)
                  </div>
                </div>
                <div className="form-group full">
                  <label>Notes / Remarks</label>
                  <textarea
                    name="notes"
                    value={addUserForm.notes}
                    onChange={handleAddUserChange}
                    placeholder="Any notes about this user account…"
                    style={{ minHeight: 52 }}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn"
                onClick={closeAddUserModal}
                disabled={addUserLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleCreateUser}
                disabled={addUserLoading}
              >
                {addUserLoading
                  ? "Creating..."
                  : "Create User & Send Credentials"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/*  user edit */}
      {isModalOpenEditUser && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 700 }}>
            <div className="modal-header">
              <div className="modal-title">
                Edit User — {selectedUser?.fullName}
              </div>
              <button className="modal-close" onClick={closeEditUserModal}>
                ✕
              </button>
            </div>

            <div className="modal-body">
              {/* ── Basic Information ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Basic Information
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    value={editUserForm.fullName}
                    onChange={handleEditUserChange}
                    placeholder="Enter full name"
                    style={
                      editUserErrors.fullName ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {editUserErrors.fullName && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editUserErrors.fullName}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Mobile Number *</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={editUserForm.mobile}
                    onChange={handleEditUserChange}
                    placeholder="+91 XXXXX XXXXX"
                    style={
                      editUserErrors.mobile ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {editUserErrors.mobile && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editUserErrors.mobile}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={editUserForm.email}
                    onChange={handleEditUserChange}
                    placeholder="email@example.com"
                    style={
                      editUserErrors.email ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {editUserErrors.email && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editUserErrors.email}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>WhatsApp Number</label>
                  <input
                    type="tel"
                    name="whatsApp"
                    value={editUserForm.whatsApp}
                    onChange={handleEditUserChange}
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>

                <div className="form-group">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    name="dob"
                    value={editUserForm.dob}
                    onChange={handleEditUserChange}
                  />
                </div>

                <div className="form-group">
                  <label>Pincode *</label>
                  <input
                    type="text"
                    name="pincode"
                    value={editUserForm.pincode}
                    onChange={handleEditPincodeChange}
                    placeholder="6-digit pincode"
                    maxLength={6}
                    style={
                      editUserErrors.pincode ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {editUserErrors.pincode && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editUserErrors.pincode}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>District</label>
                  <input
                    type="text"
                    name="district"
                    value={editUserForm.district}
                    onChange={handleEditUserChange}
                    placeholder="Auto-filled from pincode"
                    style={{
                      background: editUserForm.district
                        ? "var(--bg-secondary)"
                        : "",
                    }}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>State</label>
                <StateDropdown
                  name="stateId"
                  value={editUserForm.stateId}
                  onChange={handleEditUserChange}
                />
              </div>

              <div className="form-group full">
                <label>Complete Address *</label>
                <textarea
                  name="address"
                  value={editUserForm.address}
                  onChange={handleEditUserChange}
                  placeholder="House/Flat No., Street, Area, City, State, Pincode"
                  style={{
                    minHeight: 52,
                    ...(editUserErrors.address
                      ? { borderColor: "#dc2626" }
                      : {}),
                  }}
                />
                {editUserErrors.address && (
                  <span style={{ color: "#dc2626", fontSize: 11 }}>
                    {editUserErrors.address}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Landmark</label>
                <input
                  type="text"
                  name="landmark"
                  value={editUserForm.landmark}
                  onChange={handleEditUserChange}
                  placeholder="Near landmark"
                />
              </div>

              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  margin: "14px 0",
                }}
              />

              {/* ── KYC Information ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                KYC Information
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>PAN</label>
                  <input
                    type="text"
                    name="pan"
                    value={editUserForm.pan}
                    onChange={handleEditUserChange}
                    placeholder="ABCDE1234F"
                    maxLength={10}
                  />
                </div>
                <div className="form-group">
                  <label>Aadhaar</label>
                  <input
                    type="text"
                    name="aadhaar"
                    value={editUserForm.aadhaar}
                    onChange={handleEditUserChange}
                    placeholder="XXXX XXXX XXXX"
                    maxLength={12}
                  />
                </div>
              </div>

              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  margin: "14px 0",
                }}
              />

              {/* ── Bank Details ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Bank Details
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    value={editUserForm.bankName}
                    onChange={handleEditUserChange}
                    placeholder="Bank name"
                  />
                </div>
                <div className="form-group">
                  <label>IFSC Code</label>
                  <input
                    type="text"
                    name="ifsc"
                    value={editUserForm.ifsc}
                    onChange={handleEditUserChange}
                    placeholder="SBIN0012345"
                  />
                </div>
                <div className="form-group">
                  <label>Account Number</label>
                  <input
                    type="text"
                    name="accountNumber"
                    value={editUserForm.accountNumber}
                    onChange={handleEditUserChange}
                    placeholder="Account number"
                  />
                </div>
                <div className="form-group">
                  <label>Account Holder</label>
                  <input
                    type="text"
                    name="accountHolder"
                    value={editUserForm.accountHolder}
                    onChange={handleEditUserChange}
                    placeholder="As per bank records"
                  />
                </div>
              </div>

              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  margin: "14px 0",
                }}
              />

              {/* ── Account Settings ── */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-tertiary)",
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                Account Settings
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>
                    KYC Status{" "}
                    <span
                      style={{
                        fontWeight: 400,
                        color: "var(--amber)",
                        fontSize: 10,
                      }}
                    >
                      (use KYC Approval to change)
                    </span>
                  </label>
                  <div
                    style={{
                      padding: "8px 10px",
                      borderRadius: "var(--radius-md)",
                      border: "0.5px solid var(--border-mid)",
                      background: "var(--bg-secondary)",
                      fontSize: 13,
                      color: "var(--green)",
                    }}
                  >
                    {selectedUser?.kycStatus || "Pending"}
                  </div>
                </div>
                <div className="form-group full">
                  <label>Notes / Remarks</label>
                  <textarea
                    name="notes"
                    value={editUserForm.notes}
                    onChange={handleEditUserChange}
                    placeholder="Any notes about this user account…"
                    style={{ minHeight: 52 }}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn"
                onClick={closeEditUserModal}
                disabled={editUserLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateUser}
                disabled={editUserLoading}
              >
                {editUserLoading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/*  user kyc approval */}
      {isModalOpenKyc && (
        <div className="modal-overlay open">
          <div
            className="modal"
            style={{ width: 960, maxWidth: "98vw", maxHeight: "95vh" }}
          >
            <div className="modal-header">
              <div className="modal-title">
                User KYC Approval — Sunrise Properties Pvt Ltd
              </div>
              <button
                className="modal-close"
                onClick={() => setIsModalOpenKyc(false)}
              >
                ✕
              </button>
            </div>

            <div
              className="modal-body"
              style={{ padding: 0, display: "flex", gap: 0, minHeight: 500 }}
            >
              <div
                style={{
                  width: 220,
                  flexShrink: 0,
                  background: "#2a2a28",
                  borderRadius: "0 0 0 var(--radius-lg)",
                  padding: 16,
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    color: "#aaa",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    marginBottom: 4,
                  }}
                >
                  Document Preview
                </div>
                <div
                  style={{
                    background: "#1a1a18",
                    borderRadius: 8,
                    minHeight: 160,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#555",
                    fontSize: 12,
                    textAlign: "center",
                    padding: 12,
                  }}
                >
                  Click <b style={{ color: "#7dd3fc" }}>View</b> on any document
                  to preview it here
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#888",
                    textAlign: "center",
                    marginTop: 4,
                  }}
                >
                  Selected document will appear above
                </div>
              </div>

              <div
                style={{
                  flex: 1,
                  padding: 18,
                  overflowY: "auto",
                  borderRight: "0.5px solid var(--border-light)",
                }}
              >
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ width: 30 }}>#</th>
                      <th>Doc Name</th>
                      <th style={{ width: 80 }}>Document</th>
                      <th>Approval / Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        num: 1,
                        key: "pan",
                        label: "PAN Card",
                        required: true,
                        status: "VERIFIED",
                      },
                      {
                        num: 2,
                        key: "aadhaar",
                        label: "Aadhaar Card",
                        required: true,
                        status: "VERIFIED",
                      },
                      {
                        num: 3,
                        key: "photo",
                        label: "Photo (Passport Size)",
                        required: true,
                        status: "VERIFIED",
                      },
                      {
                        num: 4,
                        key: "gst",
                        label: "GST Registration",
                        required: false,
                        status: "VERIFIED",
                      },
                      {
                        num: 5,
                        key: "shopImg",
                        label: "Shop / Property Image",
                        required: false,
                        status: "NOT VERIFIED",
                      },
                    ].map((doc) => (
                      <tr key={doc.key}>
                        <td
                          style={{
                            color: "var(--text-tertiary)",
                            fontSize: 11,
                          }}
                        >
                          {doc.num}
                        </td>
                        <td>
                          <div style={{ fontSize: 12, fontWeight: 500 }}>
                            ℹ {doc.label}
                            {doc.required && (
                              <span style={{ color: "var(--red)" }}> *</span>
                            )}
                          </div>
                          <div style={{ marginTop: 2 }}>
                            <span
                              style={{
                                color:
                                  doc.status === "VERIFIED"
                                    ? "#27500A"
                                    : "#BA7517",
                                fontSize: 11,
                                fontWeight: 600,
                              }}
                            >
                              {doc.status === "VERIFIED"
                                ? "✓ VERIFIED"
                                : "[NOT VERIFIED]"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <button className="btn btn-xs btn-warn">View</button>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <button
                              style={{
                                width: 28,
                                height: 28,
                                borderRadius: "50%",
                                border: "2px solid #3B6D11",
                                background: "#EAF3DE",
                                cursor: "pointer",
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              title="Approve"
                            >
                              ✓
                            </button>
                            <input
                              type="text"
                              placeholder="Enter Remark Here"
                              style={{
                                flex: 1,
                                fontSize: 12,
                                padding: "5px 8px",
                              }}
                            />
                            <button
                              style={{
                                width: 28,
                                height: 28,
                                borderRadius: "50%",
                                border: "2px solid #ccc",
                                background: "transparent",
                                cursor: "pointer",
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              title="Reject"
                            >
                              ✕
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  width: 260,
                  flexShrink: 0,
                  background: "#1e2a35",
                  borderRadius: "0 0 var(--radius-lg) 0",
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    padding: "12px 14px",
                    borderBottom: "0.5px solid rgba(255,255,255,0.08)",
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#7dd3fc",
                    letterSpacing: ".06em",
                    textTransform: "uppercase",
                  }}
                >
                  User Information
                </div>
                {[
                  ["Partner Name", "Sunrise Properties Pvt Ltd [AU3710]"],
                  ["Name", "Sunrise Properties Pvt Ltd [24287]"],
                  ["Mobile", "+91 98765 43210"],
                  ["Email", "mgr@sunrise.in"],
                  ["DOB", "15 Mar 1985"],
                  ["PAN", "ABCPS1234D"],
                  ["AADHAAR", "1234 5678 9012"],
                  [
                    "Address",
                    "3rd Cross, Koramangala 5th Block, Bengaluru 560034",
                  ],
                  ["District", "Koramangala"],
                  ["State", "Karnataka"],
                  ["Pincode", "560034"],
                  ["Landmark", "Near Forum Mall"],
                  ["Package", "Growth Plan"],
                  ["Reg Date", "Jan 10, 2024"],
                  ["Account Status", "Inactive"],
                  ["KYC Status", "Verified"],
                  ["BankName", "State Bank of India"],
                  ["IFSC", "SBIN0012345"],
                  ["AccountNumber", "40123456789"],
                  ["AccountHolder", "Sunrise Properties Pvt Ltd"],
                  ["Balance", "₹2,400"],
                  ["Notes", "—"],
                ].map(([label, value]) => (
                  <div
                    key={label}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 1fr",
                      borderBottom: "0.5px solid rgba(255,255,255,0.06)",
                      padding: "7px 14px",
                      gap: 8,
                    }}
                  >
                    <span style={{ fontSize: 11, color: "#9ca3af" }}>
                      {label}
                    </span>
                    <span
                      style={{
                        fontSize: 11,
                        color: "#e5e7eb",
                        wordBreak: "break-word",
                      }}
                    >
                      {value}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <div className="flex-gap8">
                <button className="btn btn-success btn-sm">
                  ✓ Approve All
                </button>
                <button className="btn btn-danger btn-sm">✕ Reject All</button>
              </div>
              <div className="flex-gap8">
                <button
                  className="btn"
                  onClick={() => setIsModalOpenKyc(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary">Save KYC Decision</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpenLedger && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 640, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">
                Account Ledger — {selectedUserForAction?.fullName}
              </div>
              <button
                className="modal-close"
                onClick={() => setIsModalOpenLedger(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 14,
                  fontSize: 12,
                }}
              >
                <span style={{ color: "var(--text-secondary)" }}>
                  Current Balance:{" "}
                  <strong style={{ color: "var(--blue)" }}>
                    {ledgerLoading
                      ? "..."
                      : `₹${ledgerData?.currentBalance?.toLocaleString("en-IN") ?? 0}`}
                  </strong>
                </span>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Description</th>
                      <th>Type</th>
                      <th>Credit</th>
                      <th>Debit</th>
                      <th>Balance After</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ledgerLoading ? (
                      Array.from({ length: 4 }).map((_, i) => (
                        <tr key={i}>
                          {Array.from({ length: 7 }).map((_, j) => (
                            <td key={j}>
                              <div
                                style={{
                                  height: 13,
                                  borderRadius: 6,
                                  background:
                                    "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                                  backgroundSize: "200% 100%",
                                  animation: "shimmer 1.4s infinite",
                                  width: "70%",
                                }}
                              />
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : ledgerData?.transactions?.items?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={7}
                          style={{
                            textAlign: "center",
                            color: "var(--text-tertiary)",
                            padding: 24,
                          }}
                        >
                          No transactions found.
                        </td>
                      </tr>
                    ) : (
                      ledgerData?.transactions?.items?.map((tx, idx) => (
                        <tr key={tx.ledgerId}>
                          <td className="sn-col">{idx + 1}</td>
                          <td style={{ fontSize: 11, whiteSpace: "nowrap" }}>
                            {tx.createdAt
                              ? new Date(tx.createdAt).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </td>
                          <td style={{ fontSize: 11 }}>
                            <div>{tx.description || "—"}</div>
                            {tx.createdByName && (
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "var(--text-tertiary)",
                                }}
                              >
                                By: {tx.createdByName}
                              </div>
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge ${tx.txType === "Credit" ? "badge-active" : "badge-inactive"}`}
                            >
                              {tx.txType}
                            </span>
                          </td>
                          <td
                            style={{
                              color: "var(--green, #16a34a)",
                              fontWeight: 600,
                            }}
                          >
                            {tx.txType === "Credit"
                              ? `₹${tx.amount?.toLocaleString("en-IN")}`
                              : "—"}
                          </td>
                          <td
                            style={{
                              color: "var(--red, #dc2626)",
                              fontWeight: 600,
                            }}
                          >
                            {tx.txType === "Debit"
                              ? `₹${tx.amount?.toLocaleString("en-IN")}`
                              : "—"}
                          </td>
                          <td style={{ fontWeight: 600 }}>
                            ₹{tx.balanceAfter?.toLocaleString("en-IN")}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn"
                onClick={() => setIsModalOpenLedger(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isModalOpenFund && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 440, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">
                Fund Transfer — {selectedUserForAction?.fullName}
              </div>
              <button
                className="modal-close"
                onClick={() => setIsModalOpenFund(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group">
                  <label>Current Balance</label>
                  <input
                    type="text"
                    value={`₹${selectedUserForAction?.walletBalance?.toLocaleString("en-IN") ?? 0}`}
                    readOnly
                    style={{
                      background: "var(--bg-secondary)",
                      color: "var(--blue)",
                      fontWeight: 600,
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>Transfer Type</label>
                  <select
                    value={fundForm.transferType}
                    onChange={(e) =>
                      setFundForm((p) => ({
                        ...p,
                        transferType: e.target.value,
                      }))
                    }
                  >
                    <option value={1}>Credit (Add Funds)</option>
                    <option value={2}>Debit (Deduct Funds)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Amount (₹)</label>
                  <input
                    type="number"
                    min={1}
                    value={fundForm.amount}
                    placeholder="0"
                    onChange={(e) =>
                      setFundForm((p) => ({ ...p, amount: e.target.value }))
                    }
                  />
                </div>
                <div className="form-group" style={{ gridColumn: "1/-1" }}>
                  <label>Remark</label>
                  <input
                    type="text"
                    value={fundForm.remark}
                    placeholder="Reason for transfer"
                    onChange={(e) =>
                      setFundForm((p) => ({ ...p, remark: e.target.value }))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setIsModalOpenFund(false)}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleFundTransfer}
                disabled={fundLoading}
              >
                {fundLoading ? "Transferring..." : "Confirm Transfer"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
